/* AQUELIA — scripts propios (prefijo aq-) */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal al hacer scroll + cifras ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.aq-reveal:not(.aq-visible), [data-aq-contador]:not([data-aq-hecho])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('aq-visible'); if (el.hasAttribute('data-aq-contador')) pintarFinal(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('aq-visible');
        if (el.hasAttribute('data-aq-contador')) contar(el);
        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  function pintarFinal(el) {
    el.textContent = el.getAttribute('data-prefijo') + el.getAttribute('data-aq-contador') + el.getAttribute('data-sufijo');
    el.setAttribute('data-aq-hecho', '');
  }
  function contar(el) {
    if (el.hasAttribute('data-aq-hecho')) return;
    el.setAttribute('data-aq-hecho', '');
    var fin = parseFloat(el.getAttribute('data-aq-contador')) || 0;
    var pre = el.getAttribute('data-prefijo') || '', suf = el.getAttribute('data-sufijo') || '';
    var dec = (String(fin).split('.')[1] || '').length;
    var dur = 1600, t0 = null;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), ease = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + (fin * ease).toFixed(dec).replace('.', ',') + suf;
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var items = document.querySelectorAll('[data-aq-parallax]');
    if (!items.length || reduceMotion || window.innerWidth < 990) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var f = parseFloat(el.getAttribute('data-aq-parallax')) || 0;
        var r = el.getBoundingClientRect();
        var y = (r.top + r.height / 2 - window.innerHeight / 2) * f * -0.01;
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- Modos de chorro (acordeón) ---------- */
  function initModos() {
    document.querySelectorAll('[data-aq-modos]').forEach(function (wrap) {
      if (wrap.dataset.aqListo) return; wrap.dataset.aqListo = '1';
      var modos = wrap.querySelectorAll('.aq-modo');
      var img = wrap.querySelector('[data-aq-modos-img]');
      modos.forEach(function (m) {
        var b = m.querySelector('.aq-modo__btn');
        b.addEventListener('click', function () {
          modos.forEach(function (o) { o.classList.remove('is-activo'); o.querySelector('.aq-modo__btn').setAttribute('aria-expanded', 'false'); });
          m.classList.add('is-activo'); b.setAttribute('aria-expanded', 'true');
          var src = m.getAttribute('data-img');
          if (img && src && img.getAttribute('src') !== src) {
            img.style.opacity = 0;
            setTimeout(function () { img.src = src; img.style.opacity = 1; }, 250);
          }
        });
      });
    });
  }

  /* ---------- Producto: galería, cantidad, variantes, añadir al carrito ---------- */
  function initProducto() {
    document.querySelectorAll('[data-aq-producto]').forEach(function (wrap) {
      if (wrap.dataset.aqListo) return; wrap.dataset.aqListo = '1';

      var principal = wrap.querySelector('[data-aq-principal]');
      var thumbs = wrap.querySelectorAll('.aq-prod__thumb');
      function verFoto(btn) {
        thumbs.forEach(function (t) { t.classList.remove('is-activo'); });
        btn.classList.add('is-activo');
        if (!principal) return;
        principal.style.opacity = 0;
        setTimeout(function () {
          principal.src = btn.getAttribute('data-src');
          principal.srcset = btn.getAttribute('data-srcset') || '';
          principal.alt = btn.getAttribute('data-alt') || '';
          principal.style.opacity = 1;
        }, 180);
      }
      thumbs.forEach(function (btn) { btn.addEventListener('click', function () { verFoto(btn); }); });

      var cant = wrap.querySelector('[data-aq-cantidad]');
      wrap.querySelectorAll('[data-aq-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          v = Math.max(1, v + parseInt(b.getAttribute('data-aq-cant'), 10));
          cant.value = v;
        });
      });

      var form = wrap.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var boton = wrap.querySelector('[data-aq-boton]');
      var precio = wrap.querySelector('[data-aq-precio]');
      var tachado = wrap.querySelector('[data-aq-tachado]');
      var stickyBtn = document.querySelector('[data-aq-sticky-btn]');
      var stickyPrecio = document.querySelector('[data-aq-sticky-precio]');
      var datos = wrap.querySelector('[data-aq-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var formato = wrap.getAttribute('data-formato') || '{{amount_with_comma_separator}} €';
      var txtComprar = boton ? boton.getAttribute('data-texto') : '';
      var txtAgotado = boton ? boton.getAttribute('data-agotado') : '';

      function dinero(c) {
        var n = (c / 100).toFixed(2);
        var coma = n.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma).replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100));
      }
      function aplicarVariante(v) {
        if (!v) { if (boton) { boton.disabled = true; boton.querySelector('span').textContent = txtAgotado; } return; }
        if (idInput) idInput.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (stickyPrecio) stickyPrecio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; }
          else tachado.hidden = true;
        }
        if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? txtComprar : txtAgotado; }
        if (stickyBtn) stickyBtn.disabled = !v.available;
        if (v.featured_media_src) {
          var t = wrap.querySelector('.aq-prod__thumb[data-media-id="' + v.featured_media_id + '"]');
          if (t) verFoto(t);
        }
      }
      wrap.querySelectorAll('[data-aq-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          wrap.querySelectorAll('[data-aq-opcion]').forEach(function (fs) {
            var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          aplicarVariante(v);
        });
      });

      if (form) {
        form.addEventListener('submit', function (ev) {
          if (!window.fetch) return;
          ev.preventDefault();
          var err = wrap.querySelector('.aq-prod__error');
          var ok = wrap.querySelector('.aq-prod__exito');
          if (err) err.style.display = 'none';
          if (boton) boton.setAttribute('aria-busy', 'true');
          var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          var body = { items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(cant ? cant.value : 1, 10) || 1 }] };
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
          }
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (boton) boton.removeAttribute('aria-busy');
            if (res.status) { if (err) { err.textContent = res.description || res.message; err.style.display = 'block'; } return; }
            if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
              if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
              var item = res.items ? res.items[0] : res;
              drawer.renderContents(Object.assign({}, item, { sections: res.sections, id: item.id || item.variant_id, key: item.key }));
            } else if (drawer && drawer.tagName === 'CART-NOTIFICATION') {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            } else {
              if (ok) { ok.style.display = 'block'; }
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            }
          }).catch(function () { form.submit(); });
        });
      }

      /* Barra fija en móvil */
      var sticky = document.querySelector('[data-aq-sticky]');
      if (sticky && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(boton);
        if (stickyBtn) stickyBtn.addEventListener('click', function () { boton.click(); });
      }
    });
  }

  function initTodo(root) { initReveal(root); initModos(); initProducto(); }

  document.addEventListener('DOMContentLoaded', function () { initTodo(); initParallax(); });
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
